module.exports = __webpack_public_path__ + "static/media/pong-placeholder.1c892259.png";